import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {Button} from "@material-ui/core";
import PropTypes from "prop-types";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../../store";
import useProgressiveInput from "../../../../../hooks/useProgressiveInput";
import GenericDialog from "../../../../../components/ui/dialogs/generic-dialog/GenericDialog";
import {getHowManyFiltersApplied} from "../../../../utils/utils";
import {updateObject} from "../../../../utils/updateObject";
import AutocompleteWithoutIcon
    from "../../../../../components/ui/autocompletes/autocomplete-without-icon/AutocompleteWithoutIcon";
import DefaultSelect from "../../../../../components/ui/inputs/selects/default-select/DefaultSelect";

const FilterDialogContratto = (props) => {
    const dispatch = useDispatch();
    const [tagAutocompleteInput, setTagAutocompleteInput] = useState("");
    const [setTimeoutTagsAutocomplete] = useProgressiveInput(
        (searchText) => dispatch(actions.fetchSimTagsAutocomplete(searchText)), 1000);
    const filterDataPlanOrOption = useSelector(state => state.contrattoDigitaleReducer.simsAssociatedToPlanFilterData.data);
    const filterDataNotAssociated = useSelector(state => state.contrattoDigitaleReducer.simsNotAssociatedToOptionFilterData.data);
    const filterData = props.isOption ? filterDataNotAssociated : filterDataPlanOrOption
    const loading = useSelector(state => state.contrattoDigitaleReducer.apnSimFilterData.loading);
    const [currentFilters, setCurrentFilters] = useState(props.filter)
    const filterDataTags = useSelector((state) => state.simReducer.filterData.tags);

    const handleAutocompleteInputChange = (e) => {
        let inputValue = e.target.value;
        setTagAutocompleteInput(inputValue);
        if (inputValue.length > 0) {
            setTimeoutTagsAutocomplete(inputValue);
        }
    }

    const handleChange = (e, name) => {
        setCurrentFilters(prevState => updateObject(prevState, {
            [name]: updateObject(prevState[name], {value: e.target.value})
        }))
    }

    const changeTags = (name, value) => {
        setCurrentFilters(prevState => updateObject(prevState, {
            [name]: updateObject(prevState[name], {value: value})
        }))
    }

    const handleApplicaClick = () => {
        props.handleFilterSearch(currentFilters)
        props.handleDialogClose();
    }

    const dialogContent = (
        <>
            <Typography className="mb-24" variant="h5">Filtri</Typography>

            <Grid container
                  spacing={2}
                  justifyContent="space-between"
                  alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography variant={"subtitle1"}>Tag associati</Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <AutocompleteWithoutIcon placeholder="Cerca tag"
                                             bgColor="#7c92a5"
                                             searchText={tagAutocompleteInput}
                                             setSearchText={handleAutocompleteInputChange}
                                             allItems={filterDataTags}
                                             selectedItems={currentFilters.tags.value}
                                             setSelectedItems={(value) => changeTags("tags", value)}/>
                </Grid>
            </Grid>

            <Grid container
                  spacing={2}
                  justifyContent="space-between"
                  alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography variant={"subtitle1"}>Piano commerciale</Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <DefaultSelect
                        menuItems={filterData.piano}
                        handleOnChange={(e) => handleChange(e, "piano")}
                        fullWidth
                        label="Seleziona"
                        value={currentFilters.piano.value}
                    />
                </Grid>
            </Grid>

            {props.isExtraShare &&
            <Grid container
                  spacing={2}
                  justifyContent="space-between"
                  alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography variant={"subtitle1"}>Ragione sociale</Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <DefaultSelect
                        menuItems={filterData.ragioneSociale}
                        handleOnChange={(e) => handleChange(e, "regioneSociale")}
                        fullWidth
                        label="Seleziona"
                        value={currentFilters.regioneSociale?.value}
                    />
                </Grid>
            </Grid>}

        </>
    );

    const dialogActions = (
        <Grid container
              justifyContent="space-between">
            <Button color="primary"
                    variant="outlined"
                    onClick={props.handleDialogClose}>
                Annulla
            </Button>

            <Button color="primary"
                    variant="contained"
                    disabled={!getHowManyFiltersApplied(currentFilters)}
                    onClick={handleApplicaClick}>
                Applica {getHowManyFiltersApplied(currentFilters) !== 0 ? ` (${getHowManyFiltersApplied(currentFilters)})` : ""}
            </Button>
        </Grid>
    );

    return(
        <GenericDialog
            open={props.open}
            loading={loading}
            handleDialogClose={props.handleDialogClose}
            dialogContent={dialogContent}
            handleDialogCloseButton={props.handleDialogClose}
            dialogActions={dialogActions}
            dialogWidth={"md"}
        />
    )
}

FilterDialogContratto.propTypes = {
    filter: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    handleFilterSearch: PropTypes.func.isRequired,
    isOption: PropTypes.bool
}

export default FilterDialogContratto;